/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { GetApiPublicTabletBarbers200, GetApiPublicTabletBarbers400, GetApiPublicTabletBarbers403, GetApiPublicTabletBarbers404, GetApiPublicTabletBarbers500, GetApiPublicTabletBarbersPathParams, GetApiPublicTabletBarbersQueryParams, GetApiPublicTabletBarbersQueryResponse } from "../entities/GetApiPublicTabletBarbers";
import { modelsErrorResponseSchema } from "./models/errorResponseSchema";
import { modelsPublicBarbersOutputSchema } from "./models/publicBarbersOutputSchema";
import { z } from "zod/v4";

export const getApiPublicTabletBarbersPathParamsSchema = z.object({
    "branch_id": z.coerce.number().int().describe("ID филиала")
    }) as unknown as z.ZodType<GetApiPublicTabletBarbersPathParams>

export const getApiPublicTabletBarbersQueryParamsSchema = z.object({
    "branch_id": z.coerce.number().int().min(1).describe("ID филиала"),
"date": z.optional(z.string().describe("Текущий день (YYYY-MM-DD); другая дата отклоняется")),
"service_id": z.optional(z.coerce.number().int().describe("ID услуги для проверки доступности")),
"service_type": z.optional(z.enum(["adult", "child", "adult_child"]).describe("Тип услуги для проверки доступности"))
    }) as unknown as z.ZodType<GetApiPublicTabletBarbersQueryParams>

/**
 * @description OK
 */
export const getApiPublicTabletBarbers200Schema = z.lazy(() => modelsPublicBarbersOutputSchema) as unknown as z.ZodType<GetApiPublicTabletBarbers200>

/**
 * @description Некорректный branch_id, date или услуга
 */
export const getApiPublicTabletBarbers400Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<GetApiPublicTabletBarbers400>

/**
 * @description Некорректный филиальный контекст
 */
export const getApiPublicTabletBarbers403Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<GetApiPublicTabletBarbers403>

/**
 * @description Филиал или компания недоступны
 */
export const getApiPublicTabletBarbers404Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<GetApiPublicTabletBarbers404>

/**
 * @description Ошибка определения филиала или подбора мастеров
 */
export const getApiPublicTabletBarbers500Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<GetApiPublicTabletBarbers500>

export const getApiPublicTabletBarbersQueryResponseSchema = z.lazy(() => getApiPublicTabletBarbers200Schema) as unknown as z.ZodType<GetApiPublicTabletBarbersQueryResponse>